import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { FormsModule } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { getSectionNameFromRoute } from '../../../shared/models/eop_types.enum';
import { NoEmojiDirective } from '../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'introduction',
  standalone: true,
  imports: [
    LucideAngularModule,
    FormsModule,
    CommonModule,
    NoEmojiDirective
  ],
  templateUrl: './introduction.component.html',
  styleUrl: './introduction.component.css'
})
export class IntroductionComponent implements OnInit{

  private routerSubscription!: Subscription;

  icons = Icons; 
  basePath: string = '';
  title: string = '';
  page: string = '';

  showIntro: boolean = true;  // Controls visibility of the popup
  dontShowAgain: boolean = false;  // Tracks if user selected "Don't show this again"

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    // handle the initial load
    this.setBasePathFromUrl(this.router.url);
    this.checkStorage();
  
    // handle navigation changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.setBasePathFromUrl(event.urlAfterRedirects);
        this.checkStorage();  // re-check every time URL changes
      });
  } 

  private checkStorage() {
    if (isPlatformBrowser(this.platformId)) {
      const popupPreference = sessionStorage.getItem(this.page);
      this.showIntro = popupPreference !== 'true'; // show unless closed
    }
  }
  
  setBasePathFromUrl(url: string) {
    const parts = url.split('/');
    
    this.basePath = parts[parts.length - 1]; // last segment
    
    if (this.basePath == 'prepare-your-eop') {
      this.title = "Prepare Your EOP";
    } else if (parts[parts.length - 2] == 'custom-page') {
      this.basePath = 'custom-page';
      this.title = "Custom Page";
    } else {
      this.title = getSectionNameFromRoute(this.basePath) || 'N/A';
    }
    this.page = this.basePath + '-intro';
  }
  

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  closeIntro(): void {
    if (this.dontShowAgain) {
      // Save preference in localStorage so it won't show again
      sessionStorage.setItem(this.page, 'true');
    }
    this.showIntro = false;
  }
}
